import { render, staticRenderFns } from "./NationalIdentityNumber.vue?vue&type=template&id=34805fc2&"
import script from "./NationalIdentityNumber.vue?vue&type=script&lang=js&"
export * from "./NationalIdentityNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports